import { ROW_GUTTER } from '@/config';
import { Col, Row } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import './styles.less';
import { useAppContext } from '@/contexts/AppContext';
import { hasPermissions } from '@/services/roleService';
import { CompanyPermissionConfig } from '@/routers/companyRouters';
import { UserType } from '@/constants';
import { GlobalPermissionConfig } from '@/routers/globalRouters';
type Props = {
  data: { icon: JSX.Element; name: string; url: string; disabled?: boolean }[];
  title: string;
  icon: JSX.Element;
  subTitle: string;
};

export default function EntitySelect({ data, title, icon, subTitle }: Props) {
  const { auth } = useAppContext();
  const dataWithPermissions = React.useMemo(() => {
    if (auth?.userType === UserType.CompanyUser) {
      return data.filter(x => hasPermissions(CompanyPermissionConfig.__getPermission(x.url), auth));
    }
    return data.filter(x => hasPermissions(GlobalPermissionConfig.__getPermission(x.url), auth));
  }, [data, auth]);
  return (
    <Col xs={24} md={24} xl={8} xxl={8} className="entity-select">
      <img className="arrow-icon hide-on-mobile" src={require('@/assets/icons/btn-next.png')} alt="next" />
      <div className="title">
        {icon}
        <div className="text">{title}</div>
        <div className="subTitle">{subTitle}</div>
      </div>
      <div className="entity-items-container">
        <Row gutter={ROW_GUTTER}>
          {dataWithPermissions.map((e, index) => {
            return (
              <Col xs={8} md={6} xl={8} xxl={6} className={`item-container ${e.disabled ? 'disabled' : ''}`} key={index}>
                <Link to={e.url} className="item">
                  <div className="icon">{e.icon}</div>
                  <label>{e.name}</label>
                </Link>
              </Col>
            );
          })}
        </Row>
      </div>
    </Col>
  );
}
